/**
 * Luminance-mask style block shared by the agent's PNG glyphs so they can be
 * tinted via `backgroundColor` (following a button's `color`/hover). Callers set
 * the size and `backgroundColor` themselves; this only wires the mask.
 */
export function maskIconSx(src: string) {
  return {
    maskImage: `url(${src})`,
    maskMode: "luminance" as const,
    maskSize: "contain" as const,
    maskRepeat: "no-repeat" as const,
    maskPosition: "center" as const,
    WebkitMaskImage: `url(${src})`,
    WebkitMaskSize: "contain" as const,
    WebkitMaskRepeat: "no-repeat" as const,
    WebkitMaskPosition: "center" as const,
  };
}
